/******************************************
 *  Author : Suraj Sharma
 *  Created On : Fri Mar 12 2021
 *  File : index.jsx
 *******************************************/
import ClusterComapanyMap from './ClusterComapanyMap';

export default ClusterComapanyMap;